export const initialValuesBillingDetails = {
  billingName: '',
  billingEmail: '',
  billingPhone: '',
  emailForInvoices: '',
};
